import { Box, Divider, Paper, Typography, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import { congdoan_get_info } from 'components/authentication/actions';
import { academic_year__get_list, loaded, loading } from 'components/mam-non-page/actions';
import { customSelectStyles } from 'config/constants/reactSelectConstant';
import { messageHelper } from 'helpers/messageHelper';
import usePrevious from 'helpers/usePrevious';
import { get } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Document, Page } from 'react-pdf';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { callApiExportCongDoanVungAnnuallyReport } from 'redux/saga/vung/report/exportCongDoanVungAnnualReport';

function VungAnnuallyReportPage() {
    const { control, getValues, watch, setValue, trigger } = useForm();
    const dispatch = useDispatch();
    const commonReducer = useSelector((state) => state.commonReducer);
    const authenticationReducer = useSelector((state) => state.authenticationReducer);
    const congDoanId = get(authenticationReducer, 'userInfo.congDoanId');
    const congDoanInfo = useSelector((state) => state.commonReducer.congDoanInfo, null);

    const [pdfFile, setPdfFile] = useState(null);
    const [numPages, setNumPages] = useState(null);

    const theme = useTheme();

    const watches = watch();
    const values = getValues();
    const prevValues = usePrevious(values);

    const academicYearsOptions = commonReducer.academicYears
        ? commonReducer.academicYears.map((item) => {
              return { value: item, label: item.name };
          })
        : [];

    useEffect(() => {
        dispatch(congdoan_get_info());
    }, [dispatch]);

    useEffect(() => {
        dispatch(academic_year__get_list());
    }, [dispatch]);

    const onAcademicYearChange = (selectedOption) => {
        setValue('academicYear', selectedOption);
        trigger('academicYear');
    };

    const exportReportPDF = useCallback(
        (congDoanId, academicYear) => {
            dispatch(loading());
            callApiExportCongDoanVungAnnuallyReport(congDoanId, academicYear, true)
                .then((res) => {
                    const pdfURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                    setPdfFile(pdfURL);
                })
                .catch((err) => {
                    messageHelper.showError(err);
                })
                .finally(() => {
                    dispatch(loaded());
                });
        },
        [dispatch]
    );

    useEffect(() => {
        const isDiff = JSON.stringify(values) !== JSON.stringify(prevValues);
        const academicYear = get(values, 'academicYear.value.name');
        if (isDiff && academicYear && congDoanId) {
            exportReportPDF(congDoanId, academicYear);
        }
    }, [values, watches, prevValues, dispatch, exportReportPDF, congDoanId]);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const exportAnnualReport = () => {
        dispatch(loading());
        const academicYear = get(values, 'academicYear.value.name');
        callApiExportCongDoanVungAnnuallyReport(congDoanId, academicYear)
            .then((res) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `Báo cáo cộng đoàn ${get(congDoanInfo, 'congDoanName', '')} năm học ${academicYear}.xlsx`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch((err) => {
                messageHelper.showError(err);
            })
            .finally(() => {
                dispatch(loaded());
            });
    };

    return (
        <>
            <Paper elevation={3}>
                <Box p={theme.spacing(0, 3)}>
                    <Typography variant="h6">Báo cáo năm</Typography>
                </Box>
                <Divider></Divider>
                <Box p={theme.spacing(1, 1)}>
                    <form>
                        <div className="row m-0">
                            <div className="col-md-3 pr-0">
                                <div className="row mr-0">
                                    <label className="mb-0 col-md-4 fmi-label pr-0" htmlFor="monthYear">
                                        Năm học:
                                    </label>
                                    <div className="col-md-8 p-0">
                                        <Controller
                                            id="academicYear"
                                            name="academicYear"
                                            control={control}
                                            defaultValue={null}
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: 'Vui lòng nhập năm học để lấy báo cáo!',
                                                },
                                            }}
                                            render={() => {
                                                return (
                                                    <Select
                                                        onChange={onAcademicYearChange}
                                                        options={academicYearsOptions}
                                                        classNamePrefix="fmi-react-select"
                                                        styles={customSelectStyles}
                                                    />
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3"></div>
                            <div className="col-md-3"></div>
                            {watches.academicYear && (
                                <div className="col-md-3">
                                    <div className="row mx-0 w-100">
                                        <button type="button" className={clsx({ 'export-button btn btn-primary mb-1 fmi-toolbar-button': true })} onClick={exportAnnualReport}>
                                            Xuất báo cáo
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </form>
                </Box>
            </Paper>
            {pdfFile && (
                <div className="align-pdf">
                    <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
                        {Array.from(new Array(numPages), (el, index) => (
                            <Page key={index} pageNumber={index + 1}></Page>
                        ))}
                    </Document>
                </div>
            )}
        </>
    );
}

export default VungAnnuallyReportPage;
